import "assets/css/jquery.webui-popover.css";
import SVG from "../core/SVG";
import { avatar } from "utils/assets_exports/images";

import popoverImg from "assets/images/popover2.jpg";
import { DemoUserObject } from "assets/data/usersData";
import { Link } from "react-router-dom";

export type UserPopoverProps = {
    user: DemoUserObject;
};

const UserPopover = ({ user }: UserPopoverProps) => {
    return (
        <div className="webui-popover pop webui-no-padding bottom-right ">
            <div className="webui-arrow" style={{ left: "21px" }}></div>
            <div className="webui-popover-inner">
                <div className="webui-popover-content">
                    <div className="profile-popover-block">
                        <div className="profile-popover-wrapper">
                            <div className="popover-cover">
                                <img className="cover-img" src={popoverImg} />
                                <div className="popover-avatar relative">
                                    <img
                                        className="avatar"
                                        src={user.url || avatar}
                                    />
                                </div>
                                <button className="text-white px-2 py-1 rounded-full bg-momeento-50 absolute top-1 right-1 shadow-xl hover:bg-momeento-100 ">
                                    Follow
                                </button>
                            </div>

                            <div className="flex justify-between items-center gap-2 px-2 py-3">
                                <div className="popover-meta">
                                    <span className="user-meta">
                                        <Link
                                            to={`/users/view/${user.id}`}
                                            className="username text-black dark:text-white font-medium"
                                        >
                                            {user.name}
                                        </Link>
                                    </span>
                                    <div className="user-location flex justify-start items-center gap-2">
                                        <SVG
                                            svg="map-pointer"
                                            size={16}
                                            className="light-grey-svg"
                                        />
                                        <div className="text">
                                            From <a href="#">New york</a>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex flex-col gap-1 justify-center items-end">
                                    <span className="user-meta">
                                        25 Followers
                                    </span>
                                    <span className="user-meta">
                                        2 Following
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserPopover;
